'use client';

import { useMemo } from 'react';
import { SESSION_JWT_STATUS } from '../useSessionJwt/constants';
import { useSessionJwt } from '../useSessionJwt/useSessionJwt';
import { CLIENT_AUTH_STATUS } from './constants';
import type { ClientAuthentication } from './types';

const LOADING_STATE: ClientAuthentication = { status: CLIENT_AUTH_STATUS.LOADING, isAuthenticated: false, uuid: null };
const ANONYMOUS_STATE: ClientAuthentication = {
  status: CLIENT_AUTH_STATUS.ANONYMOUS,
  isAuthenticated: false,
  uuid: null,
};

/**
 * Browser counterpart of the server-side auth state: the session from useSessionJwt, reduced to who the visitor
 * is. A login in the auth dialog goes back to loading and evaluates again.
 */
export function useClientAuthentication(): ClientAuthentication {
  const { status, isAuthenticated, uuid } = useSessionJwt();

  return useMemo(() => {
    if (status === SESSION_JWT_STATUS.LOADING) return LOADING_STATE;

    if (!isAuthenticated) return ANONYMOUS_STATE;

    return { status: CLIENT_AUTH_STATUS.AUTHENTICATED, isAuthenticated: true, uuid };
  }, [status, isAuthenticated, uuid]);
}
